import { render } from "./DeleteScale.vue?vue&type=template&id=6aa2c40f&scoped=true&bindings={\"confirm\":\"options\",\"deleteable\":\"data\",\"related\":\"data\"}"
import script from "./DeleteScale.vue?vue&type=script&lang=js"
export * from "./DeleteScale.vue?vue&type=script&lang=js"

import "./DeleteScale.vue?vue&type=style&index=0&id=6aa2c40f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6aa2c40f"

export default script